import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
const baseUri = "WebApi.asmx/api/commentService";
const store = {};
const mutations = {
    GET_COMMENTS(state, posts) {
        state.commentList = posts.comments;
        state.commentListIsLoading = false;
    }, 
    SET_READ() { 
    }, 
    DELETE_CM(state, payload) {
        // Remove the deleted comment from the list when possible
        const id = payload?.CmId ?? payload?.ComId;
        if (!id) return;
        state.commentList = (state.commentList || []).filter(c => (c.ComId ?? c.CmId) !== id);
    },
    EDIT_CM(state, payload) {
        // Update the edited comment text in the list when possible
        const id = payload?.CmId ?? payload?.ComId ?? payload?.comment?.ComId;
        const newText = payload?.Comment ?? payload?.comment?.ComText;
        if (!id || typeof newText !== 'string') return;
        const idx = (state.commentList || []).findIndex(c => (c.ComId ?? c.CmId) === id);
        if (idx >= 0) {
            state.commentList[idx] = { ...state.commentList[idx], ComText: newText };
        }
    },
    SAVE_COMMENT(state, posts) {
        state.commentList = [posts.comment].concat(state.commentList);
    }, 
};
const state = {
    commentList: [],
    commentListIsLoading: false,
};
const getters = {};
const actions = {
    getCommentsForTopic({ commit }, data) {
        state.commentListIsLoading = true;
        const ctyId = (data && (data.CtyId ?? data.ctyId)) ?? 2; // Stage 0: default to Public (2). Legacy 0 treated as 2 server-side if needed.
        return axios
            .get(baseUri + '/GetComments?topicId=' + data.TopicId + '&CtyId=' + ctyId)
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_COMMENTS', res.data);
                }
                else {
                    alert(res.data.error);
                    state.commentListIsLoading = false;
                }
                return res.data;
            })
            .catch(err => {
                state.commentListIsLoading = false;
                alert(err?.message || 'Error fetching comments');
                throw err;
            });
    }, 
    setCommentAsRead({ commit }, data) { 
        return axios
            .get(baseUri + '/SetRead?topicId=' + data.TopicId)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_READ', res.data);
                }
                else {
                    alert(res.data.error);
                }
                return res.data;
            });
    }, 
    deleteComment({ commit }, data) {
        return axios
            .get(baseUri + '/DeleteComment?cmId=' + data.CmId)
            .then(res => {

                if (res.data.success == true) {
                    // Prefer refetching in component; also optimistically update state
                    commit('DELETE_CM', { CmId: data.CmId });

                }
                else {
                    alert(res.data.error);
                }
                return res.data;
            });
    }, 
    editComment({ commit }, data) {
        const formData = new FormData();
        formData.append("CmId", data.CmId);
        // Basic client-side strip of HTML tags before sending. Server must also sanitize.
        const cleanComment = (data.Comment || '').replace(/<[^>]+>/g, '');
        formData.append("Comment", cleanComment);
        return axios
            .post(baseUri + '/EditComment', formData)
            .then(res => {
                if (res.data.success == true) {
                    // Update state if possible; component also refetches
                    commit('EDIT_CM', { CmId: data.CmId, Comment: cleanComment, ...res.data });
                } else {
                    alert(res.data.error);
                }
                return res.data;
            });
    },
    saveTopicComment({ commit }, data) {
        var formData = new FormData();
        formData.append("TopicId", data.TopicId);
        // Basic client-side strip of HTML tags before sending. Server must also sanitize.
        const cleanComment = (data.Comment || '').replace(/<[^>]+>/g, '');
        formData.append("Comment", cleanComment);
        formData.append("CtyId", (data && (data.CtyId ?? data.ctyId)) ?? 2); // Stage 0: force Public (2)
        return axios
            .post(baseUri + '/SaveComment', formData) 
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_COMMENT', res.data);
                }
                else {
                    alert(res.data.error);
                }
                return res.data;
            });
    }, 
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}